// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import EmpruntProfileLayout from './EmpruntProfileLayout';

import EmpruntService from '../../services/EmpruntService';

const DeleteEmprunt = () => {
	const [emprunt, setEmprunt] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([EmpruntService.getEmprunt(id)]).then(([empruntData]) => {
			setEmprunt(empruntData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the EmpruntService to delete the Emprunt
			await EmpruntService.deleteEmprunt(id);

			// Redirect the user to the list of BulletinnotesClasses
			navigate('/services/bibliotheque/emprunts');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression du Emprunt ",
				error
			);
		}
	};

	return (
		<EmpruntProfileLayout>
			{emprunt && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{emprunt.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cet Emprunt.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez l'emprunt, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer l'Emprunt
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</EmpruntProfileLayout>
	);
};

export default DeleteEmprunt;
